// aldoo-ra/Admin/routes.js
//
// Every admin panel is registered as a lazyRoute: the route table stays
// eager (matching, routeOptions), but panel code lives in its own chunk
// loaded on first navigation. Static imports here would bundle the whole
// admin system (~4.5MB) into every visitor's page — see Router/lazy-route.
import { adminRole } from "aldoo-ra/RBAC"
import { lazyRoute } from "aldoo-ra/Router/lazy-route"

//If a module specifies a routes.js, it can export an object
//where the keys are the paths and the values are the components
// Register all routes at once using an object
export default {
    "/admin": lazyRoute(() => import("aldoo-ra/Admin/Home"), adminRole),
    "/admin/install": lazyRoute(() => import("aldoo-ra/Admin/install"), adminRole),
    "/admin/cms*": lazyRoute(() => import("aldoo-ra/CMS"), adminRole),
    "/admin/blog*": lazyRoute(() => import("aldoo-ra/Admin/Blog"), adminRole),
    "/admin/store*": lazyRoute(() => import("aldoo-ra/Admin/Store"), adminRole),
    "/admin/backups": lazyRoute(() => import("aldoo-ra/Backups"), adminRole),
    "/admin/localization*": lazyRoute(() => import("aldoo-ra/Localization/localization-editor"), adminRole),
    "/admin/mail-templates*": lazyRoute(() => import("aldoo-ra/Admin/MailTemplates"), adminRole),
    "/admin/updates*": lazyRoute(() => import("aldoo-ra/Admin/Updates"), adminRole),
    "/admin/environments": lazyRoute(() => import("aldoo-ra/Admin/Updates/Environments"), adminRole),
    "/admin/sitemap*": lazyRoute(() => import("aldoo-ra/Admin/Sitemap"), adminRole),
    "/admin/customer-support*": lazyRoute(() => import("aldoo-ra/Admin/CustomerSupport"), adminRole),
    "/admin/spam-protection*": lazyRoute(() => import("aldoo-ra/Admin/SpamProtection"), adminRole),
    "/admin/product-licensing*": lazyRoute(() => import("aldoo-ra/Admin/ProductLicensing"), adminRole),
    "/admin/platform-access*": lazyRoute(() => import("aldoo-ra/Admin/PlatformAccess"), adminRole),
    "/admin/paramio*": lazyRoute(() => import("aldoo-ra/Admin/ParamIO"), adminRole),
    "/admin/logs*": lazyRoute(() => import("aldoo-ra/Admin/Logs"), adminRole),
    "/admin/changes*": lazyRoute(() => import("aldoo-ra/Admin/History"), adminRole),
    "/admin/newsletter*": lazyRoute(() => import("aldoo-ra/Admin/Newsletter"), adminRole),
    "/newsletter": lazyRoute(() => import("aldoo-ra/Admin/Newsletter/Pages/NewsletterManagePage")),
    "/admin/site-theme*": lazyRoute(() => import("aldoo-ra/Admin/SiteTheme"), adminRole),
    "/admin/structure*": lazyRoute(() => import("aldoo-ra/Admin/Structure"), adminRole),
    "/admin/task-manager*": lazyRoute(() => import("aldoo-ra/Admin/TaskManager"), adminRole),
    "/admin/feature-matrix*": lazyRoute(() => import("aldoo-ra/Admin/FeatureMatrix"), adminRole),
    "/admin/media-library*": lazyRoute(() => import("aldoo-ra/Admin/MediaLibrary"), adminRole),
    "/admin/agents*": lazyRoute(() => import("aldoo-ra/Admin/Agents"), adminRole),
    "/admin/help-center*": lazyRoute(() => import("aldoo-ra/Admin/HelpCenter"), adminRole),
    "/admin/taxonomy*": lazyRoute(() => import("aldoo-ra/Admin/Taxonomy"), adminRole),
    "/admin/kpi*": lazyRoute(() => import("aldoo-ra/Admin/KPI"), adminRole),
    "/admin/ads*": lazyRoute(() => import("aldoo-ra/Admin/AldooAds"), adminRole),
    "/admin/downloadables*": lazyRoute(() => import("aldoo-ra/Admin/Downloadables"), adminRole),
    "/admin/sign-in": lazyRoute(() => import("aldoo-ra/Admin/Signin")),
}
